import { render, staticRenderFns } from "./AnnouncementFilters.vue?vue&type=template&id=bb19e042"
import script from "./AnnouncementFilters.vue?vue&type=script&lang=js"
export * from "./AnnouncementFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports